/**
 * Use Notifications Hook Types
 *
 * Type definitions for the notifications hook.
 *
 * @since 1.0.0
 */

/**
 * Notification variant type
 *
 * @since 1.0.0
 */
export type NotificationVariant = 'success' | 'error' | 'warning' | 'info';

/**
 * Notification interface
 *
 * @since 1.0.0
 */
export interface Notification {
  id: string;
  variant: NotificationVariant;
  message: string;
  duration?: number | false;
  dismissible?: boolean;
}
